module.exports = __webpack_public_path__ + "media/andenes/retenedor_gancho-d2be6d13.webp";